import {
  adminUserStatus,
  adminUserStatusLabel,
  type AdminUserStatus,
} from './adminUserStatus'
import type { AdminUser } from '../../services/admin'

const dotClass: Record<AdminUserStatus, string> = {
  active: 'bg-emerald-500',
  pending: 'bg-amber-400',
  deactivated: 'bg-red-500',
}

const AdminUserStatusDot: React.FC<{
  user: Pick<AdminUser, 'isActive' | 'passwordReady'>
}> = ({ user }) => {
  const status = adminUserStatus(user)
  const label = adminUserStatusLabel(status)
  return (
    <span
      className={`inline-block h-1.5 w-1.5 shrink-0 rounded-full ${dotClass[status]}`}
      title={label}
      aria-label={label}
    />
  )
}

export default AdminUserStatusDot
